import React, { useContext, useEffect } from 'react';
import { faCircleCheck, faCircleExclamation, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, showToast } from './CustomToast';
import { PlaycastContext } from '../PlaycastWrapper';

export const NotificationToastWrapper: React.FC = () => {
  // Get the context
  const context = useContext(PlaycastContext);

  useEffect(() => {
    if (!context?.stateStores?.notificationInAppState?.notification) return;

    const { title, message, type, timeoutTime } = context.stateStores.notificationInAppState.notification;

    // Map notification type to icon and color
    const getIconConfig = (type: string) => {
      switch (type) {
        case 'info':
          return { icon: faCircleInfo, iconBgColor: 'bg-blue-400' };
        case 'warning':
          return { icon: faCircleExclamation, iconBgColor: 'bg-yellow-400' };
        case 'error':
          return { icon: faCircleExclamation, iconBgColor: 'bg-red-400' };
        default:
          return { icon: faCircleCheck, iconBgColor: 'bg-green-400' };
      }
    };

    const { icon, iconBgColor } = getIconConfig(type);

    // Show toast with the notification data
    showToast({
      message: title,
      subMessage: message,
      icon,
      iconBgColor,
      duration: timeoutTime,
    });
  }, [context?.stateStores?.notificationInAppState?.notification]);

  // We still need the ToastContainer component to display the toasts
  return <ToastContainer />;
};
